import React from 'react';
import Icon3D from './Icon3D';
import { PRIME_PRICE_INR } from './api';

const TEAM = [
    {
        name: 'Nitesh Kumar',
        role: 'Founder & CEO',
        bio: 'Passionate about making renting transparent & brokerage-free for every Indian.',
        initials: 'NK',
        color: '#2563EB',
    }
];

const VALUES = [
    { icon: 'prime', title: 'Zero Brokerage', desc: 'No brokerage, no commission, no cut of your rent. Ever.' },
    { icon: 'lock', title: 'Privacy First', desc: 'Your data stays yours. We never sell or misuse personal information.' },
    { icon: 'verified', title: 'Phone Verified', desc: 'Every account is verified by phone OTP before it can post or message.' },
    { icon: 'chat', title: 'Direct Chat', desc: 'Tenants and owners talk directly. No delays, no commission agents.' },
    { icon: 'location', title: 'Ten Cities', desc: 'Bangalore, Delhi, Mumbai, Hyderabad, Pune, Chennai, Gurgaon, Noida, Kolkata and Ahmedabad.' },
    { icon: 'insights', title: 'Rent Insights', desc: 'See typical rent for an area before you contact anyone, from rents contributed by other tenants.' },
];

const STATS = [
    { value: '10', label: 'Cities Covered' },
    { value: 'OTP', label: 'Verified Accounts' },
    { value: '₹99', label: 'Prime, 30 Days' },
    { value: '₹0', label: 'Brokerage Charged' },
];

const AboutPage = ({ onBack }) => {
    return (
        <div style={{ background: '#F3F4F6', minHeight: '100vh', fontFamily: "'DM Sans', -apple-system, sans-serif" }}>

            {/* ===== BLUE GRADIENT HEADER — uses <header> so CSS :not(:has(header)) skips it ===== */}
            <header style={{
                background: 'linear-gradient(155deg, #1E40AF 0%, #2563EB 55%, #3B82F6 100%)',
                padding: '100px 20px 64px',
                position: 'relative',
                overflow: 'hidden',
            }}>
                {/* Decorative orbs */}
                <div style={{ position: 'absolute', top: '-80px', right: '-80px', width: '400px', height: '400px', background: 'rgba(255,255,255,0.05)', borderRadius: '50%', pointerEvents: 'none' }} />
                <div style={{ position: 'absolute', bottom: '-60px', left: '-60px', width: '280px', height: '280px', background: 'rgba(255,255,255,0.04)', borderRadius: '50%', pointerEvents: 'none' }} />

                <div style={{ maxWidth: '860px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
                    {/* Back button — block so nothing renders beside it */}
                    <div style={{ marginBottom: '36px' }}>
                        <button
                            onClick={onBack}
                            style={{ background: 'rgba(255,255,255,0.18)', border: '1px solid rgba(255,255,255,0.35)', color: 'white', fontWeight: '700', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '10px 22px', borderRadius: '30px', fontSize: '14px', backdropFilter: 'blur(12px)', transition: 'background 0.2s' }}
                            onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.28)'}
                            onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.18)'}
                        >
                            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
                            Back to Home
                        </button>
                    </div>

                    {/* Trust badge — on its own line below the button */}
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(255,255,255,0.14)', backdropFilter: 'blur(10px)', padding: '6px 18px', borderRadius: '20px', border: '1px solid rgba(255,255,255,0.22)', marginBottom: '20px' }}>
                        <span style={{ width: '22px', height: '22px', borderRadius: '50%', background: 'rgba(255,255,255,0.92)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginRight: '7px', verticalAlign: '-6px' }}><Icon3D name="hero-home" size={15} /></span><span style={{ fontSize: '13px', color: 'white', fontWeight: '700', letterSpacing: '0.5px' }}>Built for India</span>
                    </div>

                    <h1 style={{ fontSize: 'clamp(32px, 6vw, 54px)', fontWeight: '800', color: 'white', margin: '0 0 16px', lineHeight: '1.1', letterSpacing: '-1.5px' }}>
                        We're on a mission to<br />
                        <span style={{ color: '#F97316' }}>end rental brokerage</span>
                    </h1>
                    <p style={{ color: '#D9E6DC', fontSize: 'clamp(15px, 2vw, 18px)', lineHeight: '1.7', maxWidth: '580px', margin: 0, fontWeight: '400' }}>
                        FlatLoop was born from frustration — paying lakhs to brokers just to rent a room. We built the platform we always wished existed.
                    </p>
                </div>
            </header>

            {/* ===== STATS STRIP ===== */}
            <div style={{ maxWidth: '900px', margin: '-32px auto 0', padding: '0 20px', position: 'relative', zIndex: 10 }}>
                <div style={{ background: 'white', borderRadius: '24px', boxShadow: '0 16px 48px rgba(34,106,70,0.12)', border: '1px solid #E4EFC0', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))' }}>
                    {STATS.map((s, i) => (
                        <div key={s.label} style={{ padding: '28px 24px', textAlign: 'center', borderRight: i < STATS.length - 1 ? '1px solid #E5E9E3' : 'none' }}>
                            <div style={{ fontSize: 'clamp(24px, 4vw, 32px)', fontWeight: '900', color: '#1E40AF', letterSpacing: '-1px', lineHeight: 1 }}>{s.value}</div>
                            <div style={{ fontSize: '13px', color: '#6B7280', fontWeight: '600', marginTop: '6px' }}>{s.label}</div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ===== OUR STORY ===== */}
            <div style={{ maxWidth: '900px', margin: '64px auto', padding: '0 24px' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '32px', alignItems: 'center' }}>
                    <div>
                        <div style={{ display: 'inline-block', background: '#EFF6FF', color: '#2563EB', fontSize: '12px', fontWeight: '800', padding: '6px 16px', borderRadius: '20px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px' }}>Our Story</div>
                        <h2 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: '800', color: '#111827', margin: '0 0 16px', lineHeight: '1.2', letterSpacing: '-0.5px' }}>
                            From a tiny hostel room<br />to a pan-India platform
                        </h2>
                        <p style={{ color: '#4B5563', fontSize: '16px', lineHeight: '1.8', margin: '0 0 16px' }}>
                            In 2024, our founder was hunting for a flat in Delhi. Every single broker demanded 1–2 months' rent as commission. He said <strong>"never again"</strong> — and built FlatLoop.
                        </p>
                        <p style={{ color: '#4B5563', fontSize: '16px', lineHeight: '1.8', margin: 0 }}>
                            Today, FlatLoop connects verified tenants and property owners directly — no middlemen, no commission, no nonsense. Just honest renting.
                        </p>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                        {[
                            { year: '2024', event: 'FlatLoop founded in Delhi', icon: '🚀' },
                            { year: 'Q2 2024', event: 'Launched in 5 major cities', icon: '🏙️' },
                            { year: 'Q4 2024', event: 'Direct owner chat and zero-brokerage listings launched', icon: '💬' },
                            { year: '2025', event: 'Rent Insights launched — typical rents by area, from real tenants', icon: '📊' },
                        ].map(item => (
                            <div key={item.year} style={{ display: 'flex', alignItems: 'flex-start', gap: '16px', background: 'white', padding: '18px 20px', borderRadius: '16px', border: '1px solid #DDE3DC', boxShadow: '0 2px 8px rgba(0,0,0,0.03)' }}>
                                <div style={{ fontSize: '22px', flexShrink: 0 }}>{item.icon}</div>
                                <div>
                                    <div style={{ fontSize: '12px', color: '#2563EB', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px' }}>{item.year}</div>
                                    <div style={{ fontSize: '15px', color: '#111827', fontWeight: '700', marginTop: '2px' }}>{item.event}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ===== VALUES ===== */}
            <div style={{ background: 'white', padding: '72px 24px' }}>
                <div style={{ maxWidth: '900px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                        <div style={{ display: 'inline-block', background: '#EFF6FF', color: '#2563EB', fontSize: '12px', fontWeight: '800', padding: '6px 16px', borderRadius: '20px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px' }}>Our Values</div>
                        <h2 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: '800', color: '#111827', margin: 0, letterSpacing: '-0.5px' }}>What we stand for</h2>
                    </div>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px' }}>
                        {VALUES.map(v => (
                            <div key={v.title} style={{ background: '#F8FAFC', borderRadius: '20px', padding: '28px', border: '1px solid #DDE3DC', transition: 'all 0.2s' }}
                                onMouseOver={e => { e.currentTarget.style.borderColor = '#D9E6DC'; e.currentTarget.style.boxShadow = '0 8px 24px rgba(34,106,70,0.08)'; }}
                                onMouseOut={e => { e.currentTarget.style.borderColor = '#DDE3DC'; e.currentTarget.style.boxShadow = 'none'; }}>
                                <div style={{ marginBottom: '14px' }}><Icon3D name={v.icon} size={36} /></div>
                                <h3 style={{ fontSize: '17px', fontWeight: '800', color: '#111827', margin: '0 0 8px' }}>{v.title}</h3>
                                <p style={{ fontSize: '14px', color: '#6B7280', lineHeight: '1.7', margin: 0 }}>{v.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ===== TEAM ===== */}
            <div style={{ maxWidth: '900px', margin: '72px auto', padding: '0 24px' }}>
                <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                    <div style={{ display: 'inline-block', background: '#EFF6FF', color: '#2563EB', fontSize: '12px', fontWeight: '800', padding: '6px 16px', borderRadius: '20px', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '16px' }}>The Team</div>
                    <h2 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: '800', color: '#111827', margin: 0, letterSpacing: '-0.5px' }}>The people behind FlatLoop</h2>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '24px' }}>
                    {TEAM.map(member => (
                        <div key={member.name} style={{ background: 'white', borderRadius: '24px', padding: '32px 24px', textAlign: 'center', border: '1px solid #DDE3DC', boxShadow: '0 4px 16px rgba(0,0,0,0.04)', transition: 'all 0.2s' }}
                            onMouseOver={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 16px 40px rgba(34,106,70,0.1)'; }}
                            onMouseOut={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.04)'; }}>
                            <div style={{ width: '72px', height: '72px', borderRadius: '50%', background: `linear-gradient(135deg, ${member.color}, ${member.color}aa)`, color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '22px', fontWeight: '900', margin: '0 auto 16px', boxShadow: `0 8px 24px ${member.color}33` }}>
                                {member.initials}
                            </div>
                            <h3 style={{ fontSize: '17px', fontWeight: '800', color: '#111827', margin: '0 0 4px' }}>{member.name}</h3>
                            <div style={{ fontSize: '13px', color: member.color, fontWeight: '700', marginBottom: '12px' }}>{member.role}</div>
                            <p style={{ fontSize: '13px', color: '#6B7280', lineHeight: '1.6', margin: 0 }}>{member.bio}</p>
                        </div>
                    ))}
                </div>
            </div>

            {/* ===== CTA ===== */}
            <div style={{ background: 'linear-gradient(155deg, #1E40AF 0%, #2563EB 55%, #3B82F6 100%)', padding: '72px 24px', textAlign: 'center' }}>
                <h2 style={{ fontSize: 'clamp(26px, 5vw, 42px)', fontWeight: '800', color: 'white', margin: '0 0 16px', letterSpacing: '-1px' }}>Join 1.2 lakh+ happy renters</h2>
                <p style={{ color: '#D9E6DC', fontSize: '17px', margin: '0 0 36px', lineHeight: '1.6' }}>Zero brokerage. 100% verified. Free to search — unlock contacts with Prime at ₹{PRIME_PRICE_INR}.</p>
                <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
                    <button
                        onClick={onBack}
                        style={{ background: 'white', color: '#1E40AF', border: 'none', padding: '15px 36px', borderRadius: '16px', fontWeight: '800', fontSize: '16px', cursor: 'pointer', boxShadow: '0 8px 24px rgba(0,0,0,0.15)', transition: 'all 0.2s' }}
                        onMouseOver={e => e.currentTarget.style.transform = 'translateY(-2px)'}
                        onMouseOut={e => e.currentTarget.style.transform = 'none'}
                    >
                        Find a Flat
                    </button>
                    <a href="mailto:contact@flatloop.in"
                        style={{ background: 'rgba(255,255,255,0.18)', color: 'white', border: '1px solid rgba(255,255,255,0.38)', padding: '15px 36px', borderRadius: '16px', fontWeight: '800', fontSize: '16px', cursor: 'pointer', backdropFilter: 'blur(12px)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px', transition: 'all 0.2s' }}
                        onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.28)'}
                        onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,0.18)'}
                    >
                        ✉️ Contact Us
                    </a>
                </div>
            </div>

        </div>
    );
};

export default AboutPage;
